import { Spinner } from "@nextui-org/react";
import { Navigate } from "react-router-dom";

import { FEATURE_FLAGS } from "@/constants";
import { useFeatureFlag } from "@/hooks";
import useAuth from "@/services/useAuth";

import AnonymousMarketing from "../AnonymousMarketing/AnonymousMarketing";
import CloneVoice from "./CloneVoice/CloneVoice";

export const Voice = () => {
  const { hasFeatureFlag: hasVoice, isLoading: isVoiceLoading } = useFeatureFlag(FEATURE_FLAGS.TTS);
  const { isAuthenticated } = useAuth();

  if (isVoiceLoading) return <Spinner />;
  if (hasVoice) return isAuthenticated ? <CloneVoice /> : <AnonymousMarketing datakey="voice" />;

  return <Navigate to="/" />;
};
